import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { PermissionKey } from '../config/permissions';
import AccessDeniedPage from './AccessDeniedPage';

interface Props {
  /** key เดี่ยวหรือ array (มีสิทธิ์อย่างน้อย 1 ตัวก็ผ่าน) */
  permission?: PermissionKey | PermissionKey[];
  /** เฉพาะ merchant owner เท่านั้น (พนักงานทุกคนถูกปฏิเสธ) */
  ownerOnly?: boolean;
  children: React.ReactNode;
}

/**
 * Route guard — render AccessDeniedPage เมื่อพนักงานไม่มีสิทธิ์
 * ใช้ครอบ element ใน App.tsx (อยู่ใน Outlet ของ Layout → sidebar ยังแสดงปกติ)
 */
const RequirePermission: React.FC<Props> = ({ permission, ownerOnly, children }) => {
  const { can, isEmployee } = usePermissions();

  if (ownerOnly && isEmployee) return <AccessDeniedPage />;
  if (permission && !can(permission)) return <AccessDeniedPage />;

  return <>{children}</>;
};

export default RequirePermission;
